import { controls, currencyToNumber, grouped } from "../../controls";

const rpcf7 = {
  label: "Closed Accounts",
  starting: true,
  url: "rp101m",
  pageLabel: "Closed Accounts",
  pageType: "history",
  visitingBranches: true,
  // filteraction: true,
  filter: [
    ...controls.displayText({ tab: "general", label: "Portal", star: false }),
    ...controls.autoComplete({ tab: "general", name: "portal_scheme_code", width: "col-sm-2", controlType: "PortalScheme" }),
    ...controls.displayText({ tab: "general", label: "" }),
  ],
  form: [],
  history: {
    perPage: 50,
    reportHeader: "Closed Accounts",
    filterable: true,
    sortable: true,
    defaultsTo: 0,
    pdfProps: { pageSize: "A4", pageOrientation: "portrait" },

    displayColumns: [
      {
        Header: "Sr", type: "autoinc", accessor: "srno", align: "center", width: 30,
        width132: { size: 3 }
      },
      {
        Header: "Name",
        accessor: "marathi_name",
        rwidth: "*"
      },
      {
        Header: "Name in bank",
        accessor: "bank_name",
      },
      {
        Header: "Account Number",
        accessor: "account_number"
      },
      {
        Header: "Amount",
        accessor: "amount"
      }
    ]
  }
};

export default rpcf7;